import React, { useEffect } from "react";
import { Nav } from "../enterprise2/Nav";
import { Footer } from "../enterprise2/Footer";
import "../../enterprise-2.css";
import "../../enterprise-2-apple.css";
import "../../plan-2.css";

// Shell for the duplicated assessment flow: Enterprise 2 nav + footer around the p2-skinned pages.
export function P2Layout({ children, title = "Your AI Roadmap | Crowther" }) {
  useEffect(() => { document.title = title; }, [title]);
  return (
    <div className="e2 p2" data-testid="plan-2-root">
      <Nav active="roadmap" />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
